import React, {useState} from "react";

import {useGlobalState} from "../../../GlobalState";
import useEmailProvidersActions from "./useEmailProvidersAction";
import FormUpdate from "./FormUpdate";
import useGoogleAccount from "./useGoogleAccount";
import useSmtpOptions from "./useSmtpOptions";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import EmailProvidersRadioList from "./EmailProvidersRadioList";


const EmailProvidersCard = () => {
    const {formCreate} = useEmailProvidersActions();
    const {userData, settings, updateSettings} = useGlobalState();
    const {googleAccount, createGoogleAccount, isLoading} = useGoogleAccount();
    const smtpOptions = useSmtpOptions();

    const provider = settings?.emailProvider || "default";  // the provider saved in the db settings
    const requestAutoReplyEnabled = settings?.requestAutoReplyEnabled;   // the autoReply saved in the db settings, will be disabled if the user select default provider
    const [newProvider, setNewProvider] = useState(provider); // the provider clicked by the user when want to change it

    const handleUpdateEmailProvider = async (provider) => {
        if (provider === "default") {
            await updateSettings({emailProvider: provider, requestAutoReplyEnabled: false})
        }else{
            await updateSettings({emailProvider: provider})
        }
    }

    const handleChange = async (provider) => {
        setNewProvider(provider);
        formCreate.open();
    }

    const handleClickSelected = async (option) => {
        if(option === provider){
            if(option !== newProvider){
                setNewProvider(provider);
            }
            formCreate.open();
        }
    }

    return (
        <Card>
            <CardContent>
                <Container maxWidth='sm' disableGutters>
                    <EmailProvidersRadioList value={provider}
                                             onChange={handleChange}
                                             isLoading={isLoading}
                                             onClickSelected={handleClickSelected}/>
                </Container>
            </CardContent>

            {formCreate.show && <FormUpdate onClose={formCreate.close}
                                            initialProvider={newProvider}
                                            onSave={handleUpdateEmailProvider}
                                            initialStep={1}
                                            googleAccount={googleAccount}
                                            createGoogleAccount={createGoogleAccount}
                                            smtpOptions={smtpOptions}
                                            emailFrom={userData?.contracts?.requestContract?.email}
                                            requestAutoReplyEnabled={requestAutoReplyEnabled}/>
            }
        </Card>
    );
};

export default EmailProvidersCard;